import { useState } from 'react';

const MultiSelectGrid = ({
  options,
  onChange,
  initialValues = [],
}: {
  options: Array<{ value: number; label: string }>;
  onChange: (values: any) => void;
  initialValues?: number[];
}) => {
  const [selectedValues, setSelectedValues] = useState<number[]>(initialValues);

  const selectOption = (optionValue: number) => {
    let newValues;

    if (selectedValues.includes(optionValue)) {
      newValues = selectedValues.filter(selectedId => selectedId !== optionValue);
    } else {
      newValues = [...selectedValues, optionValue];
    }

    setSelectedValues(newValues);
    onChange(newValues);
  };

  return (
    <>
      <ul
        data-testid="multi-select-grid"
        role="list"
        className="grid gap-3 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 my-3"
      >
        {options.map(option => (
          <li
            data-testid={`option-${option.value}`}
            onClick={() => selectOption(option.value)}
            key={option.value}
            className={`flex text-center rounded-lg divide-y divide-gray-200 border border-solid hover:border-gray-600 cursor-pointer ${
              selectedValues.includes(option.value) ? 'bg-gray-100' : 'bg-white'
            }`}
          >
            <div className="text-sm font-semibold h-24 rounded-lg flex text-center items-center mx-auto px-3 text-gray-400 hover:text-gray-600">
              {option.label}
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default MultiSelectGrid;
